import { typo } from '@cycle-app/ui';
import styled from 'styled-components';

export const SectionTag = styled.span`
  ${typo.body500}
`;
